import React, { type FunctionComponent } from 'react'
import { colors } from '@retailer-platform/shared-components'
import { Link } from 'react-router-dom'
import { css } from '@emotion/react'
import {
  type CollectionDatum,
  type CollectionsRoutingConfig,
} from 'domains/collections/types/collections.types'
import { useDomainScopedPathname } from 'domains/collections/utils/domain/routing'

interface Props {
  collection: CollectionDatum
  routingConfig: CollectionsRoutingConfig
}

const linkStyles = css({
  color: colors.GRAYSCALE.X70,
  textDecoration: 'underline',

  '&:link': {
    color: colors.GRAYSCALE.X70,
  },
})

export const CollectionsListNameCell: FunctionComponent<Props> = ({
  collection,
  routingConfig,
}) => {
  const showPath = useDomainScopedPathname(routingConfig.show, {
    collectionId: collection.id,
  })

  return (
    <Link to={showPath} css={linkStyles}>
      {collection.name}
    </Link>
  )
}
